/**
 * m3 echo Frontend - Status Translations
 *
 * Translates job status from English to German
 */

export const translateStatus = (status: string): string => {
  const translations: Record<string, string> = {
    'pending': 'Ausstehend',
    'running': 'Läuft',
    'completed': 'Abgeschlossen',
    'failed': 'Fehlgeschlagen',
  };

  return translations[status] || status;
};
